import React from 'react';
import PropTypes from 'prop-types';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const FinanceStatCard = ({
    label,
    value,
    subtitle,
    warning,
    icon,
    variant = 'default',
    onClick,
    className = '',
    valueClassName = '',
    layout = 'default',
}) => {
    const isClickable = Boolean(onClick);
    const hasValue = value != null && value !== '';
    const isKpi = layout === 'kpi';

    return (
        <div
            className={`finance-stat-card finance-stat-card--${variant} ${isKpi ? 'finance-stat-card--kpi' : ''} ${warning ? 'finance-stat-card--has-warning' : ''} ${isClickable ? 'is-clickable' : ''} ${className}`.trim()}
            onClick={onClick}
            onKeyDown={isClickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') onClick?.(e); } : undefined}
            role={isClickable ? 'button' : undefined}
            tabIndex={isClickable ? 0 : undefined}
        >
            {isKpi ? (
                <>
                    <div className="finance-stat-card__kpi-icon" aria-hidden="true">{icon}</div>
                    <div className="finance-stat-card__kpi-copy">
                        <span className="finance-stat-card__label">{label}</span>
                        {hasValue && (
                            <strong className={`finance-stat-card__value ${valueClassName}`.trim()} title={String(value)}>
                                {value}
                            </strong>
                        )}
                        {subtitle && !warning && (
                            <small className="finance-stat-card__subtitle">{subtitle}</small>
                        )}
                        {warning && (
                            <div className="finance-stat-card__warning" role="alert" title={warning}>
                                <WarningAmberRoundedIcon className="finance-stat-card__warning-icon" />
                                <span className="finance-stat-card__warning-text">{warning}</span>
                            </div>
                        )}
                    </div>
                </>
            ) : (
                <>
                    <div className="finance-stat-card__layout">
                        <div className="finance-stat-card__meta">
                            <div className="finance-stat-card__icon-wrap">{icon}</div>
                            <span className={`finance-stat-card__label ${!hasValue ? 'is-primary' : ''}`.trim()}>{label}</span>
                        </div>
                        {hasValue && (
                            <span className={`finance-stat-card__value ${valueClassName}`.trim()} title={String(value)}>
                                {value}
                            </span>
                        )}
                    </div>
                    {subtitle && !warning && (
                        <span className="finance-stat-card__subtitle">{subtitle}</span>
                    )}
                    {warning && (
                        <div className="finance-stat-card__warning" role="alert">
                            <WarningAmberRoundedIcon className="finance-stat-card__warning-icon" />
                            <span className="finance-stat-card__warning-text">{warning}</span>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

FinanceStatCard.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.node,
    subtitle: PropTypes.node,
    warning: PropTypes.string,
    icon: PropTypes.node.isRequired,
    variant: PropTypes.oneOf(['default', 'income', 'expense', 'profit', 'equipment', 'withholding', 'calculator', 'payment', 'insurance', 'salary']),
    onClick: PropTypes.func,
    className: PropTypes.string,
    valueClassName: PropTypes.string,
    layout: PropTypes.oneOf(['default', 'kpi']),
};

export default FinanceStatCard;
